export default __webpack_public_path__ + "static/media/homepage-pattern.81965297.svg";